import React, { useEffect, useRef, useState } from 'react';
import { useParams, useLocation, Link } from 'react-router-dom';
import {
    Code,
    School,
    Groups,
    TrendingUp,
    Palette,
    Gavel,
    LocationOn,
    ArrowForward,
    CheckCircle,
    Phone,
    Schedule,
    AttachMoney,
    DesignServices,
    Web,
    PhoneAndroid,
    ShoppingCart,
    MenuBook,
    Build,
    Description,
    AccountBalance,
    Search,
    People,
    Assignment,
    Assessment,
    Chat,
    Email,
    MonetizationOn,
    Brush,
    DesktopMac,
    Print,
    Image,
    EmojiSymbols,
    Copyright,
    Flag,
    Balance,
    Map,
    Campaign,
    ListAlt,
    Business,
    ArrowDownward,
    Layers,
    Storage,
    Devices,
    Storefront,
    Cloud,
    Analytics,
    Security,
    SupportAgent,
    Close
} from '@mui/icons-material';
import '../../styles/Services.css';

// Modal Component
const ProposalModal = ({ isOpen, onClose, service, sectionTitle }) => {
    if (!isOpen) return null;

    return (
        <div className="modal-overlay1" onClick={onClose}>
            <div className="modal-container1" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header1">
                    <h3>Detailed Proposal: {service.title}</h3>
                    <button className="modal-close1" onClick={onClose}>
                        <Close />
                    </button>
                </div>

                <div className="modal-content1">
                    <div className="modal-service-info1">
                        <div className="modal-service-icon1">
                            <span style={{ fontSize: '32px' }}>{service.icon}</span>
                        </div>
                        <div>
                            <h4>{service.title}</h4>
                            {sectionTitle && <p className="modal-section-subtitle1">Section: {sectionTitle}</p>}
                            <p className="modal-description1">{service.description}</p>
                        </div>
                    </div>

                    <div className="modal-pricing-section1">
                        <h4>Pricing Plans</h4>
                        <div className="modal-pricing-grid1">
                            <div className="modal-pricing-card1">
                                <h5>Basic Plan</h5>
                                <div className="modal-price1">{service.pricing.basic}</div>
                                <ul>
                                    <li>Essential features</li>
                                    <li>Basic customization</li>
                                    <li>Standard support</li>
                                    <li>3 months maintenance</li>
                                </ul>
                            </div>

                            <div className="modal-pricing-card1 modal-popular1">
                                <div className="popular-tag1">Most Popular</div>
                                <h5>Standard Plan</h5>
                                <div className="modal-price1">{service.pricing.standard}</div>
                                <ul>
                                    <li>All Basic features</li>
                                    <li>Advanced customization</li>
                                    <li>Priority support</li>
                                    <li>6 months maintenance</li>
                                    <li>Training included</li>
                                </ul>
                            </div>

                            <div className="modal-pricing-card1">
                                <h5>Premium Plan</h5>
                                <div className="modal-price1">{service.pricing.premium}</div>
                                <ul>
                                    <li>All Standard features</li>
                                    <li>Full customization</li>
                                    <li>24/7 dedicated support</li>
                                    <li>1 year maintenance</li>
                                    <li>Advanced analytics</li>
                                    <li>Monthly reports</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="modal-service-details1">
                        <h4>Service Details</h4>
                        <div className="modal-details-grid1">
                            <div className="modal-detail-item1">
                                <Schedule style={{ fontSize: 20, color: service.color, marginRight: 8 }} />
                                <div>
                                    <strong>Timeline:</strong> {service.timeline}
                                </div>
                            </div>
                            <div className="modal-detail-item1">
                                <AttachMoney style={{ fontSize: 20, color: service.color, marginRight: 8 }} />
                                <div>
                                    <strong>Starting Price:</strong> {service.pricing.basic}
                                </div>
                            </div>
                            <div className="modal-detail-item1">
                                <DesignServices style={{ fontSize: 20, color: service.color, marginRight: 8 }} />
                                <div>
                                    <strong>Delivery:</strong> Fully Managed
                                </div>
                            </div>
                            <div className="modal-detail-item1">
                                <SupportAgent style={{ fontSize: 20, color: service.color, marginRight: 8 }} />
                                <div>
                                    <strong>Support:</strong> 6-12 Months Included
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-sections-overview1">
                        <h4>What's Included</h4>
                        <div className="modal-sections-list1">
                            {service.sections.map((section, index) => (
                                <div key={index} className="modal-section-item1">
                                    <span style={{ fontSize: '20px', marginRight: 12 }}>{section.icon}</span>
                                    <div>
                                        <strong>{section.title}</strong>
                                        <p className="modal-section-desc1">{section.description}</p>
                                        <ul className="modal-section-features1">
                                            {section.features.slice(0, 3).map((feature, i) => (
                                                <li key={i}>{feature}</li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="modal-footer1">
                    <button className="modal-close-btn1" onClick={onClose}>
                        Close
                    </button>
                    <a href="/contact" className="modal-contact-btn1">
                        <Phone style={{ fontSize: 18, marginRight: 8 }} />
                        Contact for Custom Quote
                    </a>
                </div>
            </div>
        </div>
    );
};

const ServiceDetail = () => {
    const { serviceType } = useParams();
    const location = useLocation();
    const sectionRefs = useRef({});
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedSection, setSelectedSection] = useState(null);

    const allServicesData = {
        "website-development": {
            "title": "Website & Application Development",
            "icon": "💻",
            "color": "#8b5cf6",
            "description": "Custom digital solutions for web and mobile applications",
            "overview": "We create robust, scalable, and user-friendly websites and applications tailored to your business needs. Our development services cover everything from simple websites to complex enterprise applications.",
            "sections": [
                {
                    "id": "frontend-development",
                    "title": "Frontend Development",
                    "icon": "🎨",
                    "features": [
                        "Business Websites",
                        "Corporate Portals",
                        "Landing Pages",
                        "Portfolio Websites",
                        "SEO-Friendly Websites"
                    ],
                    "description": "Create stunning user interfaces with modern frameworks"
                },
                {
                    "id": "backend-development",
                    "title": "Backend Development",
                    "icon": "⚙️",
                    "features": [
                        "Admin Dashboards",
                        "CRM Systems",
                        "ERP Solutions",
                        "API Development",
                        "Custom Web Applications"
                    ],
                    "description": "Build robust server-side logic and database architecture"
                },
                {
                    "id": "mobile-development",
                    "title": "Mobile Development",
                    "icon": "📱",
                    "features": [
                        "E-commerce Mobile Apps",
                        "Business Apps",
                        "Booking Apps",
                        "Educational Apps",
                        "On-Demand Service Apps"
                    ],
                    "description": "Native and cross-platform mobile applications"
                },
                {
                    "id": "e-commerce",
                    "title": "E-commerce",
                    "icon": "🛒",
                    "features": [
                        "Online Stores",
                        "Marketplace Platforms",
                        "Subscription-Based Websites",
                        "Digital Product Stores",
                        "Payment & Order Management"
                    ],
                    "description": "Complete e-commerce solutions"
                }
            ],
            "pricing": {
                "basic": "₹25,000+",
                "standard": "₹50,000+",
                "premium": "₹1,00,000+"
            },
            "timeline": "2-12 weeks"
        },
        "edu-tech": {
            "title": "Edu Tech",
            "icon": "🎓",
            "color": "#0ea5e9",
            "description": "Educational technology solutions",
            "overview": "Transform education with our innovative technology solutions. We create platforms that enhance learning experiences for students, teachers, and institutions.",
            "sections": [
                {
                    "id": "learning-platforms",
                    "title": "Learning Platforms",
                    "icon": "📚",
                    "features": [
                        "Online Learning Platforms",
                        "School & College LMS",
                        "Virtual Classroom Systems",
                        "Certification Platforms",
                        "Coaching Institute Portals"
                    ],
                    "description": "Comprehensive learning management systems"
                },
                {
                    "id": "educational-tools",
                    "title": "Educational Tools",
                    "icon": "🛠️",
                    "features": [
                        "Online Exam Platforms",
                        "Quiz & Practice Apps",
                        "Student Progress Tracking",
                        "Parent Monitoring Portals",
                        "Learning Analytics Platforms"
                    ],
                    "description": "Tools to enhance teaching and learning"
                },
                {
                    "id": "content-management",
                    "title": "Content Management",
                    "icon": "📝",
                    "features": [
                        "Course Management Systems",
                        "Video Learning Platforms",
                        "Digital Study Material Libraries",
                        "Assignment Submission Portals",
                        "Teacher Content Dashboards"
                    ],
                    "description": "Manage educational content effectively"
                },
                {
                    "id": "administration",
                    "title": "Administration",
                    "icon": "🏫",
                    "features": [
                        "School Management Systems",
                        "College ERP Platforms",
                        "Fee & Billing Systems",
                        "Attendance & Timetable Portals",
                        "Internal Communication Platforms"
                    ],
                    "description": "Streamline educational administration"
                }
            ],
            "pricing": {
                "basic": "₹30,000+",
                "standard": "₹75,000+",
                "premium": "₹1,50,000+"
            },
            "timeline": "4-16 weeks"
        },
        "hr-consultancy": {
            "title": "HR Consultancy",
            "icon": "👥",
            "color": "#f59e0b",
            "description": "Human resources solutions",
            "overview": "Streamline your HR processes with our comprehensive consultancy services. From recruitment to employee management, we provide end-to-end HR solutions.",
            "sections": [
                {
                    "id": "recruitment",
                    "title": "Recruitment",
                    "icon": "🔍",
                    "features": [
                        "Recruitment Management Systems",
                        "Job Portal Platforms",
                        "Hiring & Interview Platforms",
                        "Candidate Tracking Systems",
                        "Employee Onboarding Portals"
                    ],
                    "description": "Streamline your hiring process"
                },
                {
                    "id": "hr-management",
                    "title": "HR Management",
                    "icon": "📊",
                    "features": [
                        "HR Management Systems",
                        "Employee Self-Service Portals",
                        "Leave & Attendance Platforms",
                        "Payroll Management Systems",
                        "Compliance Management Solutions"
                    ],
                    "description": "Complete HR management solutions"
                },
                {
                    "id": "training-development",
                    "title": "Training & Development",
                    "icon": "🎯",
                    "features": [
                        "Employee Training Platforms",
                        "Corporate Learning Systems",
                        "Skill Development Portals",
                        "Internal E-Learning Platforms",
                        "Workshop & Certification Systems"
                    ],
                    "description": "Employee growth and development"
                },
                {
                    "id": "hr-analytics",
                    "title": "HR Analytics",
                    "icon": "📈",
                    "features": [
                        "HR Analytics Dashboards",
                        "Employee Performance Platforms",
                        "Attrition Analysis Systems",
                        "Salary & Compensation Dashboards",
                        "HR Reporting Solutions"
                    ],
                    "description": "Data-driven HR decisions"
                }
            ],
            "pricing": {
                "basic": "₹20,000+",
                "standard": "₹40,000+",
                "premium": "₹80,000+"
            },
            "timeline": "2-8 weeks"
        },
        "digital-marketing": {
            "title": "Digital Marketing",
            "icon": "📈",
            "color": "#10b981",
            "description": "Online marketing services",
            "overview": "Boost your online presence with our comprehensive digital marketing services. We help businesses grow through strategic marketing campaigns across all digital channels.",
            "sections": [
                {
                    "id": "seo-services",
                    "title": "SEO Services",
                    "icon": "🔍",
                    "features": [
                        "Business Website SEO",
                        "Local Business SEO",
                        "E-commerce SEO",
                        "Corporate Website Optimization",
                        "SEO Performance Reporting"
                    ],
                    "description": "Improve search engine visibility"
                },
                {
                    "id": "social-media",
                    "title": "Social Media",
                    "icon": "💬",
                    "features": [
                        "Brand Social Media Pages",
                        "Business Promotion Campaigns",
                        "Lead Generation Campaigns",
                        "Influencer Promotion Campaigns",
                        "Social Media Growth Management"
                    ],
                    "description": "Engage audiences on social platforms"
                },
                {
                    "id": "content-marketing",
                    "title": "Content Marketing",
                    "icon": "📝",
                    "features": [
                        "Business Blog Platforms",
                        "Brand Video Marketing",
                        "Educational Content Campaigns",
                        "Email Marketing Systems",
                        "Case Study & Portfolio Content"
                    ],
                    "description": "Create valuable content for your audience"
                },
                {
                    "id": "ppc-advertising",
                    "title": "PPC & Advertising",
                    "icon": "💰",
                    "features": [
                        "Google Ads Campaigns",
                        "Social Media Ad Campaigns",
                        "Corporate Lead Ads",
                        "Product Promotion Ads",
                        "Remarketing Campaigns"
                    ],
                    "description": "Paid advertising for quick results"
                }
            ],
            "pricing": {
                "basic": "₹15,000/month",
                "standard": "₹30,000/month",
                "premium": "₹60,000/month"
            },
            "timeline": "Ongoing monthly"
        },
        "graphic-designing": {
            "title": "Graphic Designing & Logo Services",
            "icon": "🎨",
            "color": "#ec4899",
            "description": "Creative design solutions",
            "overview": "Create stunning visual identities with our professional design services. From logos to complete brand guidelines, we deliver designs that make an impact.",
            "sections": [
                {
                    "id": "logo-design",
                    "title": "Logo Design",
                    "icon": "✨",
                    "features": [
                        "Brand Logo Design",
                        "Startup Branding Packages",
                        "Corporate Identity Design",
                        "Brand Guideline Documents",
                        "Animated Logo Assets"
                    ],
                    "description": "Create memorable brand identities"
                },
                {
                    "id": "ui-ux-design",
                    "title": "UI/UX Design",
                    "icon": "🖥️",
                    "features": [
                        "Website UI Design",
                        "Mobile App UI Design",
                        "Dashboard UI Design",
                        "User Experience Optimization",
                        "Design System Creation"
                    ],
                    "description": "User-centered design solutions"
                },
                {
                    "id": "print-design",
                    "title": "Print Design",
                    "icon": "🖨️",
                    "features": [
                        "Marketing Brochures",
                        "Business Stationery",
                        "Promotional Flyers",
                        "Product Packaging Designs",
                        "Outdoor Advertising Designs"
                    ],
                    "description": "Professional print materials"
                },
                {
                    "id": "digital-graphics",
                    "title": "Digital Graphics",
                    "icon": "📱",
                    "features": [
                        "Social Media Creatives",
                        "Website Visual Assets",
                        "Presentation Designs",
                        "Infographic Designs",
                        "Icon & Illustration Sets"
                    ],
                    "description": "Graphics for digital platforms"
                }
            ],
            "pricing": {
                "basic": "₹5,000+",
                "standard": "₹15,000+",
                "premium": "₹30,000+"
            },
            "timeline": "1-4 weeks"
        },
        "trademark-copyright": {
            "title": "Trademark & Copyright Services",
            "icon": "⚖️",
            "color": "#6366f1",
            "description": "Intellectual property protection",
            "overview": "Protect your intellectual property with our expert trademark and copyright services. We handle everything from filing to enforcement.",
            "sections": [
                {
                    "id": "trademark-services",
                    "title": "Trademark Services",
                    "icon": "™️",
                    "features": [
                        "Brand Trademark Registration",
                        "Business Name Protection",
                        "Logo Trademark Filing",
                        "Trademark Renewal Services",
                        "International Trademark Support"
                    ],
                    "description": "Protect your brand identity"
                },
                {
                    "id": "copyright-services",
                    "title": "Copyright Services",
                    "icon": "©️",
                    "features": [
                        "Website Content Copyright",
                        "Software & App Copyright",
                        "Creative Work Protection",
                        "Digital Rights Protection",
                        "Copyright Licensing Support"
                    ],
                    "description": "Protect your creative works"
                },
                {
                    "id": "ip-strategy",
                    "title": "IP Strategy",
                    "icon": "🎯",
                    "features": [
                        "Startup IP Planning",
                        "Brand Protection Strategy",
                        "IP Risk Assessment",
                        "Competitor IP Analysis",
                        "IP Asset Valuation"
                    ],
                    "description": "Strategic intellectual property planning"
                },
                {
                    "id": "legal-support",
                    "title": "Legal Support",
                    "icon": "⚖️",
                    "features": [
                        "Legal Documentation Services",
                        "IP Agreement Drafting",
                        "Compliance Verification",
                        "Legal Notice Handling",
                        "Expert IP Consultation"
                    ],
                    "description": "Legal support for IP matters"
                }
            ],
            "pricing": {
                "basic": "₹8,000+",
                "standard": "₹20,000+",
                "premium": "₹50,000+"
            },
            "timeline": "1-12 months"
        },
        "local-advertisement": {
            "title": "Local Advertisement Services",
            "icon": "📍",
            "color": "#f97316",
            "description": "Local business promotion",
            "overview": "Grow your local business with targeted advertising solutions. We help you reach customers in your area through multiple channels.",
            "sections": [
                {
                    "id": "local-seo",
                    "title": "Local SEO",
                    "icon": "🗺️",
                    "features": [
                        "Local Business SEO",
                        "Google Maps Ranking Services",
                        "City-Based Business Promotion",
                        "Local Search Visibility Boost",
                        "Review & Reputation Management"
                    ],
                    "description": "Get found by local customers"
                },
                {
                    "id": "local-advertising",
                    "title": "Local Advertising",
                    "icon": "📢",
                    "features": [
                        "Local Paid Ad Campaigns",
                        "Neighborhood Business Promotion",
                        "Event-Based Advertising",
                        "Area-Targeted Marketing",
                        "Local Brand Awareness Campaigns"
                    ],
                    "description": "Targeted local advertising"
                },
                {
                    "id": "directory-listings",
                    "title": "Directory Listings",
                    "icon": "📋",
                    "features": [
                        "Business Directory Listings",
                        "Industry-Specific Listings",
                        "Local Review Platforms",
                        "City Portals & Media Listings",
                        "Community Business Boards"
                    ],
                    "description": "List your business in local directories"
                },
                {
                    "id": "local-presence",
                    "title": "Local Presence",
                    "icon": "🏢",
                    "features": [
                        "Local Content Marketing",
                        "Community Engagement Campaigns",
                        "Local PR & News Promotion",
                        "Influencer-Based Local Marketing",
                        "Hyperlocal Branding Strategies"
                    ],
                    "description": "Build strong local presence"
                }
            ],
            "pricing": {
                "basic": "₹10,000/month",
                "standard": "₹25,000/month",
                "premium": "₹50,000/month"
            },
            "timeline": "Ongoing monthly"
        }
    };

    useEffect(() => {
        const hash = location.hash.replace('#', '');
        if (hash && sectionRefs.current[hash]) {
            setTimeout(() => {
                sectionRefs.current[hash].scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 100);
        }
    }, [location.hash, serviceType]);

    const handleProposalClick = (sectionTitle = null) => {
        setSelectedSection(sectionTitle);
        setModalOpen(true);
    };

    const service = allServicesData[serviceType];

    if (!service) {
        return (
            <div className="service-not-found">
                <h2>Service Not Found</h2>
                <p>Return to <Link to="/services">Services</Link></p>
            </div>
        );
    }

    const ServiceIcon = service.icon;

    return (
        <>
            <div className="service-detail1">
                {/* Hero Banner */}
                <div className="service-hero-banner1">
                    <div className="service-hero-content1">
                        <div className="service-hero-icon1">
                            <ServiceIcon style={{ fontSize: 48, color: service.color }} />
                        </div>
                        <h1>{service.title}</h1>
                        <p className="service-hero-description1">{service.description}</p>
                        <div className="service-hero-features1">
                            {service.features?.map((feature, index) => (
                                <div key={index} className="hero-feature1">
                                    <CheckCircle style={{ fontSize: 16, color: service.color, marginRight: 8 }} />
                                    <span>{feature}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div className="scroll-indicator1">
                        <ArrowDownward style={{ fontSize: 24, color: '#64748b' }} />
                    </div>
                </div>

                <div className="service-detail-container1">
                    {/* Left Sidebar */}
                    <div className="service-sidebar1">
                        <div className="service-quick-info1">
                            <div className="quick-info-card1">
                                <h4>Quick Information</h4>
                                <div className="info-item1">
                                    <div className="info-label1">
                                        <AttachMoney style={{ fontSize: 16, marginRight: 8 }} />
                                        <span>Starting Price</span>
                                    </div>
                                    <span className="info-value1">{service.pricing.basic}</span>
                                </div>
                                <div className="info-item1">
                                    <div className="info-label1">
                                        <Schedule style={{ fontSize: 16, marginRight: 8 }} />
                                        <span>Timeline</span>
                                    </div>
                                    <span className="info-value1">{service.timeline}</span>
                                </div>
                                <div className="info-item1">
                                    <div className="info-label1">
                                        <DesignServices style={{ fontSize: 16, marginRight: 8 }} />
                                        <span>Delivery</span>
                                    </div>
                                    <span className="info-value1">Fully Managed</span>
                                </div>
                            </div>

                            <div className="service-navigation1">
                                <h4>Service Sections</h4>
                                <ul className="section-nav1">
                                    {service.sections.map((section, index) => {
                                        const SectionIcon = section.icon;
                                        return (
                                            <li key={index}>
                                                <a
                                                    href={`#${section.id}`}
                                                    className="nav-link1"
                                                >
                                                    <SectionIcon style={{ fontSize: 20, marginRight: 12 }} />
                                                    {section.title}
                                                </a>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>

                            <div className="cta-box1">
                                <h4>Start Your Project</h4>
                                <p className="cta-description1">Get professional consultation for your requirements</p>
                                <button
                                    className="cta-button1"
                                    onClick={() => handleProposalClick()}
                                >
                                    <Phone style={{ fontSize: 20, marginRight: 8 }} />
                                    Request Detailed Proposal
                                </button>
                                <p className="cta-note1">Response within 24 hours</p>
                            </div>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="service-main-content1">
                        {/* Overview */}
                        <section className="service-overview1">
                            <h2>Service Overview</h2>
                            <p>{service.overview}</p>
                            <div className="overview-features1">
                                <div className="overview-feature1">
                                    <Layers style={{ fontSize: 24, color: service.color, marginBottom: 12 }} />
                                    <h4>Scalable Solutions</h4>
                                    <p>Built to grow with your business needs</p>
                                </div>
                                <div className="overview-feature1">
                                    <Security style={{ fontSize: 24, color: service.color, marginBottom: 12 }} />
                                    <h4>Secure & Reliable</h4>
                                    <p>Enterprise-grade security measures</p>
                                </div>
                                <div className="overview-feature1">
                                    <SupportAgent style={{ fontSize: 24, color: service.color, marginBottom: 12 }} />
                                    <h4>Dedicated Support</h4>
                                    <p>Ongoing maintenance and updates</p>
                                </div>
                            </div>
                        </section>

                        {/* Sections */}
                        <div className="service-sections1">
                            {service.sections.map((section, index) => {
                                const SectionIcon = section.icon;
                                return (
                                    <section
                                        key={index}
                                        id={section.id}
                                        ref={el => sectionRefs.current[section.id] = el}
                                        className="service-section1"
                                    >
                                        <div className="section-header1">
                                            <div className="section-icon1">
                                                <SectionIcon style={{ fontSize: 32, color: service.color }} />
                                            </div>
                                            <div>
                                                <h3>{section.title}</h3>
                                                <p className="section-subtitle1">{section.description}</p>
                                            </div>
                                        </div>

                                        <div className="features-grid1">
                                            {section.features.map((feature, featureIndex) => (
                                                <div
                                                    key={featureIndex}
                                                    className="feature-card1"
                                                >
                                                    <CheckCircle style={{ fontSize: 18, color: service.color, marginRight: 12 }} />
                                                    <span>{feature}</span>
                                                </div>
                                            ))}
                                        </div>

                                        <div className="section-cta1">
                                            <button
                                                className="inquire-button1"
                                                onClick={() => handleProposalClick(section.title)}
                                            >
                                                Request Detailed Proposal
                                                <ArrowForward style={{ fontSize: 18, marginLeft: 8 }} />
                                            </button>
                                        </div>
                                    </section>
                                );
                            })}
                        </div>

                        {/* Pricing Section */}
                        <section className="pricing-section1">
                            <h2>Pricing Plans</h2>
                            <p className="pricing-subtitle1">Choose the plan that fits your requirements</p>
                            <div className="pricing-cards1">
                                <div className="pricing-card1">
                                    <div className="pricing-header1">
                                        <h4>Basic</h4>
                                        <div className="price1">{service.pricing.basic}</div>
                                    </div>
                                    <ul className="pricing-features1">
                                        <li><CheckCircle style={{ fontSize: 16, color: '#10b981', marginRight: 8 }} /> Essential features</li>
                                        <li><CheckCircle style={{ fontSize: 16, color: '#10b981', marginRight: 8 }} /> Basic customization</li>
                                        <li><CheckCircle style={{ fontSize: 16, color: '#10b981', marginRight: 8 }} /> Standard support</li>
                                        <li><CheckCircle style={{ fontSize: 16, color: '#10b981', marginRight: 8 }} /> 3 months maintenance</li>
                                    </ul>
                                </div>

                                <div className="pricing-card popular1">
                                    <div className="popular-badge1">Most Popular</div>
                                    <div className="pricing-header1">
                                        <h4>Standard</h4>
                                        <div className="price1">{service.pricing.standard}</div>
                                    </div>
                                    <ul className="pricing-features1">
                                        <li><CheckCircle style={{ fontSize: 16, color: '#10b981', marginRight: 8 }} /> All Basic features</li>
                                        <li><CheckCircle style={{ fontSize: 16, color: '#10b981', marginRight: 8 }} /> Advanced customization</li>
                                        <li><CheckCircle style={{ fontSize: 16, color: '#10b981', marginRight: 8 }} /> Priority support</li>
                                        <li><CheckCircle style={{ fontSize: 16, color: '#10b981', marginRight: 8 }} /> 6 months maintenance</li>
                                        <li><CheckCircle style={{ fontSize: 16, color: '#10b981', marginRight: 8 }} /> Training included</li>
                                    </ul>
                                </div>

                                <div className="pricing-card1">
                                    <div className="pricing-header1">
                                        <h4>Premium</h4>
                                        <div className="price1">{service.pricing.premium}</div>
                                    </div>
                                    <ul className="pricing-features1">
                                        <li><CheckCircle style={{ fontSize: 16, color: '#10b981', marginRight: 8 }} /> All Standard features</li>
                                        <li><CheckCircle style={{ fontSize: 16, color: '#10b981', marginRight: 8 }} /> Full customization</li>
                                        <li><CheckCircle style={{ fontSize: 16, color: '#10b981', marginRight: 8 }} /> 24/7 dedicated support</li>
                                        <li><CheckCircle style={{ fontSize: 16, color: '#10b981', marginRight: 8 }} /> 1 year maintenance</li>
                                        <li><CheckCircle style={{ fontSize: 16, color: '#10b981', marginRight: 8 }} /> Advanced analytics</li>
                                        <li><CheckCircle style={{ fontSize: 16, color: '#10b981', marginRight: 8 }} /> Monthly reports</li>
                                    </ul>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            {/* Proposal Modal */}
            <ProposalModal
                isOpen={modalOpen}
                onClose={() => setModalOpen(false)}
                service={service}
                sectionTitle={selectedSection}
            />
        </>
    );
};

export default ServiceDetail;